export default __webpack_public_path__ + "static/media/C242253.8bf5d2c5.jpg";